import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query
} from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';

function Checkouthistory() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const [bookings, setbookings] = useState([]);
  const [username, setusername] = useState();
  const [userData, setUserData] = useState();
  const [loadincount, setloadincount] = useState(true);
  const [searchText, setsearchText] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10; // 🔥 adjust as needed

  useEffect(() => {
    const unsubAuth = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUserData(user);
        if (loadincount) {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setusername(docSnap.data().username);
            setloadincount(false);
          }
        }
      }
    });
    return () => unsubAuth();
  }, []);

  useEffect(() => {
    // Real-time listener for all checkout history
    const q = query(collection(db, 'checkouthistory'), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (querySnapshot) => {
      const allData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        data: doc.data()
      }));
      setbookings(allData);
    }, (error) => {
      Toast.fire({ icon: "error", title: error.message });
    });
    return () => unsub();
  }, []);

  // 🔎 Search filter
  const filteredBookings = searchText
    ? bookings.filter((item) =>
      item.data.customers?.custname?.toUpperCase().includes(searchText.toUpperCase())
    )
    : bookings;

  // 🔢 Pagination logic
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredBookings.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredBookings.length / recordsPerPage);

  return (
    <div>
      <Menu />
      <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary" style={{ textTransform: "uppercase" }}>
              || Checkout History ||
            </button>
            <div className="card card-primary card-outline mt-2">
              <div className="p-1">
                <input
                  type="search"
                  value={searchText}
                  onChange={(e) => {
                    setCurrentPage(1); // reset to first page on search
                    setsearchText(e.target.value);
                  }}
                  className='form-control col-sm-4'
                  placeholder='Type here......'
                />
              </div>
              <div className="card-body table-responsive p-0">
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Invoice No</th>
                      <th>Customer Name</th>
                      <th>Mobile</th>
                      <th>Checkin Date</th>
                      <th>Checkout Date</th>
                      <th style={{ width: 200 }}>Rooms</th>
                      <th style={{ textAlign: "right" }}>Total</th>
                      <th style={{ textAlign: "right" }}>Paid</th>
                      <th style={{ textAlign: "right" }}>Remaining</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.map((item, index) => (
                      <tr key={item.id}>
                        <td width="80">{indexOfFirstRecord + index + 1}</td>
                        <td>{item.data.invoiceno}</td>
                        <td>{item.data.customers?.custname}</td>
                        <td>{item.data.customers?.mobile}</td>
                        <td>{moment(item.data.checkindate).format('DD/MM/YYYY')}</td>
                        <td>{moment(item.data.checkoutdate).format('DD/MM/YYYY')}</td>
                        <td>
                          <div className='row'>
                            {item.data.rooms?.map((room, i) => (
                              <span key={i}>{room.roomname} &nbsp;</span>
                            ))}
                          </div>
                        </td>
                        <td style={{ textAlign: "right" }}>{item.data.totalamount?.toFixed(2)}</td>
                        <td style={{ textAlign: "right" }}>{item.data.advance?.toFixed(2)}</td>
                        <td style={{ textAlign: "right" }}>{item.data.remaining?.toFixed(2)}</td>
                        <td>
                          <a href={`/print-invoice/${item.data.bookingid}`} className='btn btn-info btn-sm'>
                            <i className="fa fa-print"></i>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination controls */}
                <div className="d-flex justify-content-between align-items-center p-2">
                  <span>Page {currentPage} of {totalPages}</span>
                  <div>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(prev => prev - 1)}
                    >
                      Prev
                    </button>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(prev => prev + 1)}
                    >
                      Next
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Checkouthistory
